module.exports = __webpack_public_path__ + "img/paypal.4fd7aef5.png";